import { DROPOFF, PICKUP } from '../assets/constant'
import "isomorphic-fetch"

const SRB_API_BASE = api_base

function createRequestJSON(url, method, headers = {}, body = undefined) {
  return createRequest(url, method, headers, body)
  .then(catchError)
  .then(response => response.json())
}

function catchError(response) {
  if (response.status >= 200 && response.status < 300) {
      return response;
  } else {
      if (response.status == 401) throw new TypeError("Unauthorized");
      if (response.status == 404) throw new TypeError("Not found");
      if (response.status == 400) return response;
      const body = { error: response.text(), code: response.status };
      return new Promise(resolve => resolve({ json: () => body }));
  }
}

function createRequest(url, method, headers = {}, body = undefined) {
  return fetch(url, {
    method,
    headers,
    body,
  })
}

function getHeaders(user_token) {
  return  {
    'Content-Type': 'application/json',
    'Authorization': 'Token token=' + user_token
  }
}

export function fetchSizesApi(user_token) {
  var url = api_base + 'jigsizes'
  return createRequestJSON(url, 'get', getHeaders(user_token));
}

export function fetchUserApi(shipback_id, user_agent) {
  var url = api_base + 'anonymous'
  var body = JSON.stringify({shipback_id: shipback_id, user_agent: user_agent})
  return createRequestJSON(url, 'post', {'Content-Type': 'application/json'}, body);
}

export function fetchCompanyApi(company_id, user_token) {
  var url = api_base + 'companies/' + company_id
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function fetchCountriesApi(company_id, user_token) {
  var url = api_base + 'companies/' + company_id + "/countries"
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function fetchShipbackApi(shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function updateSizeApi(size, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id
  var body = JSON.stringify({ size: size })
  return createRequestJSON(url, 'put', getHeaders(user_token), body)
}

export function updateModeApi(mode, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id
  var body = JSON.stringify({ mode: mode })
  return createRequestJSON(url, 'put', getHeaders(user_token), body)
}

export function setDropoffApi(dropoff_code, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id
  var body = JSON.stringify({ dropoff_code: dropoff_code, mode: DROPOFF })
  return createRequestJSON(url, 'put', getHeaders(user_token), body)
}

export function setPickupApi(pickup_datetime, pickup_duration, pickup_slot_id, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id
  var body = JSON.stringify(
    { pickup_datetime: pickup_datetime,
      pickup_duration: pickup_duration,
      pickup_slot_id: pickup_slot_id,
      mode: PICKUP
    })
  return createRequestJSON(url, 'put', getHeaders(user_token), body)
}

export function payShipbackApi(payment_method_id, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + '/stripe'
  var body = (payment_method_id == null) ? {} : { payment_method_id: payment_method_id }
  return createRequestJSON(url, 'post', getHeaders(user_token), JSON.stringify(body))
}

export function freeShipbackApi(shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + '/free'
  var body = undefined
  return createRequestJSON(url, 'post', getHeaders(user_token), JSON.stringify(body))
}

export function fetchCustomerApi(shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/customer"
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function updateCustomerApi(customer, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/customer"
  var body = JSON.stringify(customer)
  return createRequestJSON(url, 'put', getHeaders(user_token), body)
}

export function fetchItemsApi(shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/items"
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function postItemApi(item_id, reason_code, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/returned_items"
  var body = JSON.stringify({item_id, reason_code})
  return createRequestJSON(url, 'post', getHeaders(user_token), body)
}

export function updateItemReasonApi(item_id, reason_code, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/returned_items/" + item_id
  var body = JSON.stringify({reason_code: reason_code})
  return createRequest(url, 'put', getHeaders(user_token), body)
}

export function deleteItemApi(item_id, shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/returned_items/" + item_id
  return createRequest(url, 'delete', getHeaders(user_token))
}

export function fetchQuotesApi(shipback_id, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/quotes"
  return createRequestJSON(url, 'get', getHeaders(user_token))
}

export function fetchDetailsQuoteApi(shipback_id, mode, user_token) {
  var url = api_base + 'shipbacks/' + shipback_id + "/quotes/" + mode
  return createRequestJSON(url, 'get', getHeaders(user_token))
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/api.js